import { Checkbox } from 'src/components/atoms';
import { CellContext, type RowData } from 'src/lib/tanstack-react-table';
import isEmpty from 'lodash/isEmpty';
import { StyledWrapper } from './CheckboxCell.styled';
import { useTableCheckbox } from './useTableCheckbox';

export const CheckboxCell = <TType extends RowData>({ getValue }: CellContext<TType, string>) => {
  const cellValue = getValue();
  const { isChecked, handleChange } = useTableCheckbox(cellValue);

  if (isEmpty(cellValue)) return null;

  return (
    <StyledWrapper>
      <Checkbox checked={isChecked} onChange={handleChange} />
    </StyledWrapper>
  );
};
